import styled from "styled-components"

export const StyledDisclaimer = styled.p`
    margin-top: 2.5rem;
    margin-bottom: .5rem;
    font-size: 1.4rem;
    color: ${props => props.theme.color.grayDark2};
    text-align: center;
    padding: 0 .5rem;
`